module.exports = __webpack_public_path__ + "img/vip_yaoshi.53652c3a.png";